<mat-nav-list class="menu" (mouseenter)="mouseenter()" (mouseleave)="mouseleave()">
    <mat-list-item routerLink="./profile" routerLinkActive [activated]="currentUrl ? currentUrl.includes('profile') : null">
        <mat-icon mat-list-icon>account_box</mat-icon>
        @if (isExpanded || isShowing) {
            <span class="full-width">{{ 'NavMenu.Profile' | translate }}</span>
        }
    </mat-list-item>

    <mat-divider class="divider"></mat-divider>

    <mat-list-item [disabled]="!currentOrganization" routerLink="./management/organizations" routerLinkActive [activated]="currentUrl ? currentUrl.includes('organization') : null">
        <mat-icon mat-list-icon>corporate_fare</mat-icon>
        @if (isExpanded || isShowing) {
            <span class="full-width">{{ 'NavMenu.Organizations' | translate }}</span>
        }
    </mat-list-item>

    <mat-list-item [disabled]="!currentOrganization" routerLink="./management/groups" routerLinkActive [activated]="currentUrl ? currentUrl.includes('group') : null">
        <mat-icon mat-list-icon>group</mat-icon>
        @if (isExpanded || isShowing) {
            <span class="full-width">{{ 'NavMenu.Groups' | translate }}</span>
        }
    </mat-list-item>

    <mat-list-item [disabled]="!currentOrganization" routerLink="./management/users" routerLinkActive [activated]="currentUrl ? currentUrl.includes('user') : null">
        <mat-icon mat-list-icon>person</mat-icon>
        @if (isExpanded || isShowing) {
            <span class="full-width">{{ 'NavMenu.Users' | translate }}</span>
        }
    </mat-list-item>

    <mat-list-item [disabled]="!currentOrganization" routerLink="./management/applications" routerLinkActive [activated]="currentUrl ? currentUrl.includes('application') : null">
        <mat-icon mat-list-icon>apps</mat-icon>
        @if (isExpanded || isShowing) {
            <span class="full-width">{{ 'NavMenu.Applications' | translate }}</span>
        }
    </mat-list-item>

    <mat-divider class="divider"></mat-divider>

    <mat-list-item
        [disabled]="!currentOrganization"
        routerLink="./definitions/property-definitions"
        routerLinkActive
        [activated]="currentUrl ? currentUrl.includes('property-definition') : null">
        <mat-icon mat-list-icon>manage_accounts</mat-icon>
        @if (isExpanded || isShowing) {
            <span class="full-width">{{ 'NavMenu.Properties' | translate }}</span>
        }
    </mat-list-item>

    <mat-list-item
        [disabled]="!currentOrganization"
        routerLink="./definitions/right-definitions"
        routerLinkActive
        [activated]="currentUrl ? currentUrl.includes('right-definition') : null">
        <mat-icon mat-list-icon>admin_panel_settings</mat-icon>
        @if (isExpanded || isShowing) {
            <span class="full-width">{{ 'NavMenu.Rights' | translate }}</span>
        }
    </mat-list-item>
</mat-nav-list>
